import React from "react";
import { Button } from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import MainHeader from "../../../components/MainHeader";
import MainHeaderButtonsWrapper from "../../../components/MainHeaderButtonsWrapper";
import Title from "../../../components/Title";
import { Can } from "../../../components/Can";
import { i18n } from "../../../translate/i18n";

/**
 * Header de la página Connections: título y un único botón «Agregar conexión», que abre el
 * selector de canal (`AddConnectionDialog`, doc 0447 D7). Antes era un botón dividido que
 * abría WhatsApp directamente y escondía el resto de canales tras una flecha.
 *
 * @param {object}   user      — Objeto usuario con `profile` para <Can>
 * @param {Function} onOpenAdd — abre el selector de canal
 */
const ConnectionsHeader = ({ user, onOpenAdd }) => (
  <MainHeader>
    <Title>{i18n.t("connections.title")}</Title>
    <MainHeaderButtonsWrapper>
      <Can
        role={user.profile}
        perform="connections-page:addConnection"
        yes={() => (
          <Button
            variant="contained"
            color="primary"
            disableElevation
            startIcon={<AddIcon />}
            onClick={onOpenAdd}
            style={{ textTransform: "none", fontWeight: 600, borderRadius: 20, padding: "8px 18px" }}
          >
            {i18n.t("connections.addDialog.button")}
          </Button>
        )}
      />
    </MainHeaderButtonsWrapper>
  </MainHeader>
);

export default ConnectionsHeader;
